import type { SupplierSource } from '../../lib/vendorInvoiceApi';

// D99 item 3: the supplier list is partial when the server could not read a source. ONE map from
// the server's source name to words a person uses.
export const SUPPLIER_SOURCE_LABEL: Record<SupplierSource, string> = {
  vendor_invoice: 'supplier invoices',
  historical_quotation: 'past quotations',
  price_list: 'price lists',
  master_catalogue: 'the catalogue',
};

export function SupplierSourcesNote({ sources }: { sources: SupplierSource[] }) {
  if (!sources.length) return null;
  const labels = sources.map((s) => SUPPLIER_SOURCE_LABEL[s] ?? s);
  return (
    <div role="status" className="px-3 py-1 border-b border-[#D7DBD9] bg-amber-50 text-xs text-amber-800 font-['Public_Sans']">
      Could not read: {labels.join(', ')}. The list may be incomplete.
    </div>
  );
}
